module.exports = __webpack_public_path__ + "img/am.7e8631a3.svg";